import { Autocomplete, Box, Button, Checkbox, Chip, TextField, Typography } from '@mui/material';

export const normalizeCampaignOptions = (rows = []) => {
    const options = new Map();
    (Array.isArray(rows) ? rows : []).forEach((row) => {
        const id = String(row?.id ?? row?.campaignId ?? row?.CAMPAIGN_ID ?? '').trim();
        if (!id) return;
        const accountId = String(row?.accountId ?? row?.ACCOUNT_ID ?? '').trim();
        const key = accountId ? `${accountId}:${id}` : id;
        const name = String(row?.name ?? row?.campaignName ?? row?.CAMPAIGN ?? row?.CAMPAIGN_NAME ?? id).trim() || id;
        options.set(key, { id, key, name, accountId, raw: row });
    });
    return [...options.values()].sort((a, b) => a.name.localeCompare(b.name) || a.key.localeCompare(b.key));
};

export const selectionPayload = (selectedIds) => ({
    campaignFilterActive: Array.isArray(selectedIds),
    campaignIds: Array.isArray(selectedIds) ? selectedIds : [],
});

export default function CampaignSelectionFilter({ options = [], selectedIds = [], onChange, loading = false }) {
    const selected = new Set((selectedIds || []).map(String));
    const values = options.filter((option) => selected.has(option.id) || selected.has(option.key));
    const allSelected = options.length > 0 && values.length === options.length;

    return (
        <Box sx={{ display: 'grid', gap: 1.25, minWidth: 0 }}>
            <Autocomplete
                multiple
                disableCloseOnSelect
                options={options}
                value={values}
                loading={loading}
                isOptionEqualToValue={(option, value) => option.key === value.key}
                getOptionLabel={(option) => option.name}
                onChange={(_, next) => onChange(next.map((option) => option.id))}
                noOptionsText="No campaigns are available for this date range"
                renderOption={(props, option, state) => (
                    <li {...props} key={option.key}>
                        <Checkbox checked={state.selected} sx={{ mr: 1 }} />
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="body2" fontWeight={700} noWrap>{option.name}</Typography>
                            <Typography variant="caption" color="text.secondary">Campaign {option.id}</Typography>
                        </Box>
                    </li>
                )}
                renderTags={(value, getTagProps) => value.slice(0, 3).map((option, index) => (
                    <Chip {...getTagProps({ index })} key={option.key} label={option.name} size="small" />
                )).concat(value.length > 3 ? [<Chip key="more" label={`+${value.length - 3} more`} size="small" />] : [])}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Campaigns shown"
                        placeholder={values.length ? '' : 'Choose campaigns'}
                        helperText={allSelected ? `All ${options.length} campaigns are included` : `${values.length} of ${options.length} campaigns selected`}
                    />
                )}
            />
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button type="button" size="small" onClick={() => onChange(options.map((option) => option.id))} disabled={!options.length || allSelected}>
                    Select all
                </Button>
                <Button type="button" size="small" onClick={() => onChange([])} disabled={!values.length}>
                    Deselect all
                </Button>
            </Box>
        </Box>
    );
}
